import { useCallback } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useCurrentUserAsync } from '#src/app/shared/hooks/session';
import type { ShareActionsOptions } from '#src/app/shared/hooks/share';
import { isLoaded } from '#src/app/shared/utils/async';

// eslint-disable-next-line max-lines-per-function
export function useGetVictoriousShareContent(): ShareActionsOptions['getContent'] {
	const { translate, translatePlural } = useI18n();
	const {
		data: {
			petition: {
				displayTitle,
				signatureState: { signatureCount },
			},
		},
	} = usePetitionDetailsPageData();

	const currentUserState = useCurrentUserAsync();

	const currentUser = isLoaded(currentUserState) ? currentUserState.value : undefined;
	const currentUserName = currentUser?.shortDisplayName;

	return useCallback(
		(channel, type, { url }) => {
			switch (channel) {
				case 'twitter':
					return translatePlural('fe.components.petition_share.share_text_twitter_victory', signatureCount.displayed, {
						signature_count: signatureCount.displayedLocalized,
						petition_title: displayTitle,
					});
				case 'whatsapp':
					return translate('fe.components.petition_share.share_text_whatsapp_victory', {
						petition_title: displayTitle,
					});
				case 'vk':
					return translatePlural('fe.components.petition_share.share_text_victory', signatureCount.displayed, {
						signature_count: signatureCount.displayedLocalized,
					});
				case 'line':
					return translatePlural('fe.components.petition_share.share_text_victory', signatureCount.displayed, {
						signature_count: signatureCount.displayedLocalized,
					});
				case 'email':
					if (type === 'title')
						return translatePlural('fe.components.petition_share.share_text_victory', signatureCount.displayed, {
							signature_count: signatureCount.displayedLocalized,
						});
					return translate('fe.components.petition_share.email_body_victory', {
						petition_title: displayTitle,
						petition_url: url,
						sender_name: currentUserName || '',
					});
				case 'sms':
					return translatePlural('fe.components.petition_share.share_text_sms_victory', signatureCount.displayed, {
						signature_count: signatureCount.displayedLocalized,
					});
				default:
					return '';
			}
		},
		[
			currentUserName,
			displayTitle,
			signatureCount.displayed,
			signatureCount.displayedLocalized,
			translate,
			translatePlural,
		],
	);
}
